import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';

import { MatCheckboxModule, MatIconModule } from '@angular/material';

import { GeneralDialogComponent } from './dialog/general-dialog.component';
import { GeneralDialogResultComponent } from './dialog/general-dialog-result/general-dialog-result.component';
import { MessageComponent } from './message/message.component';
import { CapsLockOnDirective } from './directives/caps-lock-on.directive';
import { ClickOutsideDirective } from './directives/click-outside.directive';
import { SessionStorageService } from './services/session-storage.service';
import { DropdownComponent } from './dropdown/dropdown.component';
import { LoanCardComponent } from './loan-card/loan-card.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { SidenavComponent } from './sidenav/sidenav.component';
import { RouterModule } from '@angular/router';
import { MessageDisplayService } from './services/message-display.service';
import { PasswordValidatorComponent } from './passwords/password-validator/password-validator.component';
import { PasswordErrorFooterComponent } from './passwords/password-error-footer/password-error-footer.component';
import { ApiService } from './services/api.service';
import { MatRadioModule } from '@angular/material';
import { ScrollingService } from '../../utilities/services/scrolling.service';
import { TimeoutDialogComponent } from '../timeout-dialog/timeout-dialog.component';
import { SessionTimeoutService } from './services/session-timeout.service';
import { MessagesService } from './services/messages.service';
import { ExpiredPasswordComponent } from './expired-password/expired-password.component';
import { PhonePipe } from './pipes/phone.pipe';
import { CheckNAPipe } from './pipes/check-na.pipe';
import { PaginationComponent } from './pagination/pagination.component';
import { PleaseWaitButtonComponent } from './please-wait-button/please-wait-button.component';
import { ExternalLinkDialogComponent } from './dialog/external-link-dialog/external-link-dialog.component';
import { TableComponent } from './table/table.component';
import { Requestor } from '@openid/appauth';
import { Html5Requestor } from './services/authorization/html5_requestor';
import { ZipPipe } from './pipes/zip.pipe';
import { WildcardPipe } from './pipes/wildcard.pipe';
import { ShortenPipe } from './pipes/shorten.pipe';
import { MonthsPipe } from './pipes/months.pipe';
import { VernacularBooleanPipe } from './pipes/vernacular-boolean.pipe';
import { ZeroToPrimaryPipe } from './pipes/zero-to-primary.pipe';
import { GoogleAnalyticsService } from './services/google-analytics.service';
import { InternationalPhonePipe } from './pipes/international-phone.pipe';
import { NoSpaceIntPhonePipe } from './pipes/no-space-int-phone.pipe';

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    MatCheckboxModule,
    ReactiveFormsModule,
    FormsModule,
    MatRadioModule,
    RouterModule,
    MatIconModule
  ],
  exports: [
    GeneralDialogComponent,
    GeneralDialogResultComponent,
    CommonModule,
    CapsLockOnDirective,
    ClickOutsideDirective,
    MessageComponent,
    DropdownComponent,
    LoanCardComponent,
    SidenavComponent,
    PasswordValidatorComponent,
    PasswordErrorFooterComponent,
    PleaseWaitButtonComponent,
    PhonePipe,
    CheckNAPipe,
    ExternalLinkDialogComponent,
    PaginationComponent,
    FlexLayoutModule,
    TableComponent,
    ZipPipe,
    WildcardPipe,
    ShortenPipe,
    MonthsPipe,
    VernacularBooleanPipe,
    ZeroToPrimaryPipe,
    InternationalPhonePipe,
    NoSpaceIntPhonePipe
  ],
  declarations: [
    GeneralDialogComponent,
    GeneralDialogResultComponent,
    CapsLockOnDirective,
    ClickOutsideDirective,
    MessageComponent,
    DropdownComponent,
    LoanCardComponent,
    SidenavComponent,
    PasswordValidatorComponent,
    PasswordErrorFooterComponent,
    ExpiredPasswordComponent,
    PleaseWaitButtonComponent,
    PhonePipe,
    CheckNAPipe,
    ExternalLinkDialogComponent,
    PaginationComponent,
    TableComponent,
    ZipPipe,
    WildcardPipe,
    ShortenPipe,
    MonthsPipe,
    VernacularBooleanPipe,
    ZeroToPrimaryPipe,
    InternationalPhonePipe,
    NoSpaceIntPhonePipe,
  ],
  providers: [
    SessionTimeoutService,
    SessionStorageService,
    ApiService,
    MessageDisplayService,
    ScrollingService,
    MessagesService,
    GoogleAnalyticsService,
    InternationalPhonePipe,
    NoSpaceIntPhonePipe,
    { provide: Requestor, useValue: new Html5Requestor() },
  ],
   entryComponents: [ GeneralDialogResultComponent, TimeoutDialogComponent]
})
export class SharedModule {
}
